import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@22.19.7_@vue+compiler-sfc@3.5.27_cac@6.7._e567e5e2b2142444d629666a5f614a9e/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}